var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLeaved
    ? _c(
        "div",
        {
          staticClass: "modal-cover",
          attrs: { "data-grm-comp": "Chat" },
          on: { click: _vm.onClose },
        },
        [
          _c(
            "div",
            {
              staticClass: "chat-container",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "chat-header-container" }, [
                _c("button", {
                  staticClass: "close-modal",
                  on: { click: _vm.onClose },
                }),
                _c("div", [_vm._v(_vm._s(_vm.$t("camstudy.chat.title")))]),
                _c("div", { staticClass: "chat-icon" }),
              ]),
              _c(
                "div",
                {
                  ref: "scroll",
                  staticClass: "chat-body-container overflow-auto",
                },
                [
                  _c("div", { staticClass: "warning-info" }, [
                    _c("div", { staticClass: "warning-title" }, [
                      _vm._v(_vm._s(_vm.$t("camstudy.chat.reportTitle"))),
                    ]),
                    _c("div", { staticClass: "warning-message" }, [
                      _vm._v(_vm._s(_vm.$t("camstudy.chat.reportMessage"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "chat-list" },
                    [
                      _c("div", {
                        ref: "chatScroll",
                        staticClass: "chat-scroll",
                      }),
                      _c("MyChat"),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", { staticClass: "chat-input-container" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-20 flex-shrink-0 chat-input-select-container",
                  },
                  [
                    _c("GrmCamstudySelect", {
                      attrs: {
                        title: _vm.$t("camstudy.chat.target"),
                        name: "whisper-target",
                        list: _vm.displayChatTargetList,
                        value: _vm.selectedWhisperTarget,
                      },
                      on: { onChange: _vm.onChangeWhisperTarget },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "chat-input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputValue,
                        expression: "inputValue",
                      },
                    ],
                    ref: "input-real",
                    attrs: {
                      type: "text",
                      maxlength: "1000",
                      placeholder: _vm.$t("camstudy.chat.inputPlaceholder"),
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.sendChat.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.inputValue = $event.target.value
                      },
                    },
                  }),
                  _c("input", {
                    ref: "input-fake",
                    staticClass: "fake-input",
                    attrs: { type: "text" },
                  }),
                  _c("button", {
                    staticClass: "send-chat",
                    class: { possible: _vm.inputLengthCheck },
                    on: { click: _vm.sendChat },
                  }),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }